import {
  ERROR_LOADING_CONDITIONS,
  GET_ALL_CONDITIONS,
  RESET_DATA,
  START_LOADING_CONDITIONS,
  STOP_LOADING_CONDITIONS,
} from "./action-types";
import initialState from "./initialState";

export const conditionsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case START_LOADING_CONDITIONS:
      return {
        ...state,
        stateIs: "Pending",
      };

    case ERROR_LOADING_CONDITIONS:
      return {
        ...state,
        stateIs: "Error",
      };

    case STOP_LOADING_CONDITIONS:
      return {
        ...state,
        stateIs: "Idle",
      };
    case GET_ALL_CONDITIONS:
      const conditions = action.payload.conditions.map((item: any) => {
        const { conditionName, id, types, dateAdded, status } = item;
        const data = {
          id: id,
          conditionName: {
            conditionName: conditionName,
            id: id,
            status: status,
          },
          dateAdded: dateAdded,
          types: types,
        };

        return data;
      });

      return {
        ...state,
        data: {
          conditions: conditions,
          totalItems: action.payload.totalItems,
          totalPages: action.payload.totalPages,
          currentPage: action.payload.currentPage,
        },
        message: "",
        stateIs: "Idle",
      };
    case RESET_DATA: {
      return initialState;
    }
    default:
      return state;
  }
};
